const STORAGE_KEY = "eventBooking:attribution";
const MAX_LEN = 300;
const UTM_FIELDS = [["utm_source", "utmSource"], ["utm_medium", "utmMedium"], ["utm_campaign", "utmCampaign"], ["utm_content", "utmContent"]];
const clean = value => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed ? trimmed.slice(0, MAX_LEN) : null;
};
const getStorage = win => {
  try {
    return win.sessionStorage;
  } catch (error) {
    return null;
  }
};

/**
 * Pure: builds attribution from what the browser actually gave us on landing.
 * Missing values are left out; nothing is invented. The landing URL has no query string
 * (it can carry tokens or return URLs); UTM values are captured separately.
 */
export const buildAttribution = function () {
  let {
    search = "",
    referrer = "",
    origin = "",
    pathname = ""
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const attribution = {};
  let params;
  try {
    params = new URLSearchParams(search);
  } catch (error) {
    params = new URLSearchParams("");
  }
  UTM_FIELDS.forEach(_ref => {
    let [param, field] = _ref;
    const value = clean(params.get(param));
    if (value) attribution[field] = value;
  });
  const ref = clean(referrer);
  if (ref) attribution.referrer = ref;
  const landing = clean("".concat(origin).concat(pathname));
  if (landing) attribution.landingUrl = landing;
  return attribution;
};

/**
 * Stores attribution once per browser session (first landing wins).
 * Returns the stored attribution (possibly an empty object).
 */
export const captureAttribution = function () {
  let win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof window !== "undefined" ? window : null;
  if (!win) return {};
  const storage = getStorage(win);
  const search = win.location ? win.location.search : "";
  const pathname = win.location ? win.location.pathname : "";
  // A landing with utm_* or on a booking route is a fresh, explicit attribution: it replaces the stored one.
  let params;
  try {
    params = new URLSearchParams(search);
  } catch (error) {
    params = new URLSearchParams("");
  }
  const hasUtm = UTM_FIELDS.some(_ref2 => {
    let [param] = _ref2;
    return clean(params.get(param));
  });
  const overwrite = hasUtm || pathname.includes("/prenota-evento");
  if (!overwrite) {
    try {
      const existing = storage && storage.getItem(STORAGE_KEY);
      if (existing) return JSON.parse(existing);
    } catch (error) {
      // unreadable value: capture again below
    }
  }
  const attribution = buildAttribution({
    search,
    referrer: win.document ? win.document.referrer : "",
    origin: win.location ? win.location.origin : "",
    pathname
  });
  try {
    if (storage) storage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (error) {
    // storage blocked: still return what we captured for this page view
  }
  return attribution;
};

/** Attribution for the booking request, or undefined when nothing was captured. */
export const getAttribution = function () {
  let win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof window !== "undefined" ? window : null;
  const attribution = captureAttribution(win);
  return attribution && Object.keys(attribution).length > 0 ? attribution : undefined;
};
export const ATTRIBUTION_STORAGE_KEY = STORAGE_KEY;